import { render } from "./showInfoProfile.vue?vue&type=template&id=604b54f9&scoped=true"
import script from "./showInfoProfile.vue?vue&type=script&lang=js"
export * from "./showInfoProfile.vue?vue&type=script&lang=js"

import "./showInfoProfile.vue?vue&type=style&index=0&id=604b54f9&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604b54f9"]])

export default __exports__